import { ErrorHandler, Injectable } from '@angular/core';

/**
 * หลัง deploy build ใหม่ ไฟล์ chunk hash เก่าใน image เดิมจะถูกแทนที่ทั้งหมด — ถ้าผู้ใช้เปิดแท็บค้างไว้ตอน deploy
 * แล้วไป lazy-load route ที่ยังไม่เคยโหลด browser จะไปขอไฟล์ chunk hash เก่า (จาก manifest ที่ค้างอยู่ใน memory)
 * ซึ่งไม่มีอยู่แล้วบน server -> 404 -> ChunkLoadError
 * ไม่มีทางแก้ที่ฝั่ง client โดยไม่ reload เพราะ manifest ของ build เดิมอ้างอิงไฟล์ที่หายไปจริง ๆ
 * จึงจับ error นี้แล้วสั่ง reload หน้าเพื่อดึง index.html + manifest ของ build ปัจจุบันมาใหม่
 */
@Injectable()
export class ChunkErrorHandler extends ErrorHandler {
  private static readonly RELOAD_FLAG_KEY = 'surveybox:chunk-reload-at';
  // กันเผลอวน reload รัว ๆ ถ้า error ไม่ได้มาจาก stale chunk จริง ๆ (เช่น server เสียถาวร)
  private static readonly RELOAD_COOLDOWN_MS = 10_000;

  override handleError(error: any): void {
    if (this.isChunkLoadError(error)) {
      this.reloadOnce();
      return;
    }
    super.handleError(error);
  }

  private isChunkLoadError(error: any): boolean {
    const message = (error?.message || error?.toString?.() || '') as string;
    return /ChunkLoadError/i.test(message) || /Loading chunk [\w-]+ failed/i.test(message);
  }

  private reloadOnce(): void {
    const lastReload = Number(sessionStorage.getItem(ChunkErrorHandler.RELOAD_FLAG_KEY) || 0);
    const now = Date.now();
    if (now - lastReload < ChunkErrorHandler.RELOAD_COOLDOWN_MS) return; // เพิ่ง reload ไปแล้ว ไม่ต้องวนอีก
    sessionStorage.setItem(ChunkErrorHandler.RELOAD_FLAG_KEY, String(now));
    window.location.reload();
  }
}
